import { flagError } from 'error-handling'
import { useFormErrorModal } from './useFormErrorModal'

export const useFormErrorHandler = () => {
  const { t, locale } = useI18n()
  const { $rollbar } = useNuxtApp()
  const { showError } = useFormErrorModal()

  const getEmailForLanguage = () => {
    switch (locale.value) {
      case 'sv':
        return 'givarservice@djurensratt.se'
      default:
        return 'donations@project1882.org'
    }
  }

  const reportError = (err: unknown, step: string, extra?: Record<string, any>) => {
    // Log to console and Rollbar (prettify extra)
    flagError(err, `form-step/${step}`, $rollbar, extra ?? {})

    showError(
      t('error.generic.title'),
      t('error.generic.contact', { email: getEmailForLanguage() }),
      t('error.generic.tryAgain'),
    )
  }

  return { reportError }
}
